// timer for CFPT
function startTimerCFPT(s)
{
// s=checkTime(s);
var minSec=checkTime(s);
var min = minSec[0];
var sec = minSec[1];
// document.getElementById("trialText").style.marginTop = "145px";//added by Daniel; why????
document.getElementById("topRight").innerHTML=min+":"+sec;
// if(listArrays[allColumns.indexOf('test')][trialRow] == "CFPT"){document.getElementById("topRight").innerHTML=":"+s;}
timerCFPTDisplay=setTimeout(function(){startTimerCFPT(s)},1000);
s=s-1;
if (s<10 && listArrays[allColumns.indexOf('test')][trialRow] == "CFPT") {
  document.getElementById("topRight").style.color = "#dc143c";
}
//when timer is up
if (s<0) {
  clearTimeout(timerCFPTDisplay);
  if (listArrays[allColumns.indexOf('test')][trialRow] == "CFPT")
  {
    document.getElementById("topRight").innerHTML = "Time up!";
    // $('#sortImg').sortable({ disabled: true });//old jquery sortable code
    // sortCFPT.destroy();//new sortable package
    sortCFPT.option('disabled',true);//new sortable package
    document.getElementById("CFPT").style.opacity = "0.4";
  }
}
}


// timer for the rest
function startTimer(s)
{
var minSec=checkTime(s);
var min = minSec[0];
var sec = minSec[1];
document.getElementById('timer').innerHTML=min+":"+sec;
timerDisplay=setTimeout(function(){startTimer(s)},1000);
s=s-1;
//when timer is up
if (s<0) {clearTimeout(timerDisplay);}
}



// function checkTime(i){
//     m=i%60;
//     i=i-60*m;
//     if (i<10){
//       i="0" + i;
//     }
//     return m;i;
// }
var checkTime = function(i) {
    var m = Math.floor(i/60);
    var s = i-60*m;
    if (s<10){s="0" + s;}
    if (m==0){m='';}    
    return [m, s];
};
// end
